









































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'

import MapLocation from '@/classes/MapLocation'
import DateHourRange from '@/classes/DateHourRange'

import useSeats, { SeatsValue } from '@/composables/use-seats'

export default defineComponent({
  props: {
    location: {
      type: MapLocation as PropType<MapLocation | null>,
      default: null,
    },
    dateHourRange: {
      type: DateHourRange as PropType<DateHourRange | null>,
      default: null,
    },
    seats: {
      type: String as PropType<SeatsValue>,
      default: null,
    },
    filterCount: {
      type: Number as PropType<Number | null>,
      default: null,
    },
  },
  setup (props, { emit }) {
    const click = (e: Event) => emit('click', e)
    const clickFilter = (e: Event) => {
      emit('click-filter', e)
    }

    const locationText = computed(() => props.location?.name)
    const rangeTexts = computed((): [string, string] => {
      const { dateHourRange: range } = props

      if (!range) return Array(2).fill('') as [string, string]
      return [range.start.dateHourString, range.end.dateHourString]
    })

    const { getName: getSeatsName } = useSeats()

    const isFilterActive = computed(() => Number(props.filterCount) > 0)

    return {
      click,
      clickFilter,
      locationText,
      rangeTexts,
      getSeatsName,
      isFilterActive,
    }
  },
})
